/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var SupportBlue = function SupportBlue(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Support icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['support--blue--paint0_linear', 'support--blue--paint1_linear', 'support--blue--paint2_linear', 'support--blue--paint3_linear', 'support--blue--paint4_linear', 'support--blue--paint5_linear', 'support--blue--paint6_linear', 'support--blue--paint7_linear', 'support--blue--paint8_linear', 'support--blue--paint9_linear', 'support--blue--paint10_linear', 'support--blue--paint11_linear', 'support--blue--filter0_f'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    viewBox: "0 0 140 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v178H0z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: ".47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.817 92.008l70 40.309L139.589.5H.045v131.953l69.772-40.445z",
    fill: "url(#".concat(gradientIds['support--blue--paint0_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.817 92.008l70 40.309L139.589.5H.045v131.953l69.772-40.445z",
    fill: "url(#".concat(gradientIds['support--blue--paint1_linear'], ")")
  })), /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M.045 132.453l69.772-40.445 70.182 40.445-69.726 40.491L.045 132.453z",
    fill: "url(#".concat(gradientIds['support--blue--paint2_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M140 132.453l-.046 5.102L70.228 178l.046-5.056L140 132.453z",
    fill: "url(#".concat(gradientIds['support--blue--paint3_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M70.274 172.944L70.228 178 0 137.555l.046-5.102 70.228 40.491z",
    fill: "url(#".concat(gradientIds['support--blue--paint4_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.265 122.433l-1.049-.638-.045-25.005 1.048.638.046 25.005z",
    fill: "url(#".concat(gradientIds['support--blue--paint5_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.751 78.89l.092 25.051-31.578 18.492-.046-25.005 31.532-18.537z",
    fill: "url(#".concat(gradientIds['support--blue--paint6_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".6",
    d: "M33.22 97.428l-1.05-.638 31.533-18.492 1.05.593L33.22 97.428z",
    fill: "url(#".concat(gradientIds['support--blue--paint7_linear'], ")")
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(gradientIds['support--blue--filter0_f'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4747C6",
    fillOpacity: "0.15",
    d: "M44.056 132.022l33.7-19.456L97.89 124.19l-33.7 19.456z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.694 109.407l-1.05-.638 31.532-18.492 1.05.592-31.532 18.538z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.784 134.412l-1.049-.638-.091-25.005 1.049.638.091 25.005z",
    fill: "url(#".concat(gradientIds['support--blue--paint8_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.225 90.87l.091 25.05-31.532 18.492-.091-25.005 31.532-18.538z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.803 137.19l-1.048-.637-.092-25.006 1.05.638.09 25.005z",
    fill: "url(#".concat(gradientIds['support--blue--paint9_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.713 112.185l-1.05-.638 31.532-18.492 1.096.593-31.578 18.537z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M86.29 93.648l.046 25.05-31.532 18.492-.092-25.005L86.29 93.648z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.869 140.06l-1.049-.638-.091-25.005 1.049.638.09 25.005z",
    fill: "url(#".concat(gradientIds['support--blue--paint10_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.778 115.054l-1.05-.637 31.533-18.492 1.095.592-31.578 18.537z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M91.355 96.517l.046 25.051-31.532 18.492-.091-25.005 31.577-18.538z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.844 117.833l-1.096-.638 31.578-18.492 1.05.593-31.532 18.537z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.888 142.838l-1.049-.638-.09-25.005 1.094.638.045 25.005z",
    fill: "url(#".concat(gradientIds['support--blue--paint11_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M96.375 99.295l.045 25.051-31.532 18.492-.045-25.005 31.532-18.538z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint0_linear'],
    x1: "69.954",
    y1: "21.574",
    x2: "69.954",
    y2: "175.037",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F2FF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".996",
    stopColor: "#88A0FF",
    stopOpacity: ".5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint1_linear'],
    x1: "69.931",
    y1: ".5",
    x2: "69.931",
    y2: "132.453",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint2_linear'],
    x1: "129.5",
    y1: "150.5",
    x2: "28.109",
    y2: "83.335",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#D5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#D6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#91BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#97AEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint3_linear'],
    x1: "70.207",
    y1: "155.241",
    x2: "140.008",
    y2: "155.241",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DDDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint4_linear'],
    x1: "0",
    y1: "155.242",
    x2: "70.254",
    y2: "155.242",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#97C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint5_linear'],
    x1: "31.397",
    y1: "67.737",
    x2: "31.328",
    y2: "87.022",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#C2B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint6_linear'],
    x1: "37.202",
    y1: "131.533",
    x2: "56.49",
    y2: "75.568",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#D8D0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint7_linear'],
    x1: "22.206",
    y1: "65.742",
    x2: "50.965",
    y2: "90.047",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#908EFF",
    stopOpacity: ".4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint8_linear'],
    x1: "49.207",
    y1: "134.415",
    x2: "49.207",
    y2: "108.765",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F2F4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint9_linear'],
    x1: "54.239",
    y1: "137.201",
    x2: "54.239",
    y2: "111.55",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F2F4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint10_linear'],
    x1: "59.303",
    y1: "140.06",
    x2: "59.303",
    y2: "114.41",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F2F4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--blue--paint11_linear'],
    x1: "64.335",
    y1: "142.846",
    x2: "64.335",
    y2: "117.195",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F2F4F8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: gradientIds['support--blue--filter0_f'],
    x: "40.056",
    y: "108.565",
    width: "61.836",
    height: "39.082",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2",
    result: "effect1_foregroundBlur"
  }))));
};
SupportBlue.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var SupportBlue$1 = SupportBlue;

export { SupportBlue$1 as default };
